import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { getApiUrl } from '../utils/api';

export const useModuleOffers = () => {
  const { tenantSlug } = useParams();
  const { user } = useAuth();
  const scope = `${tenantSlug}:${user?.user_id}`;
  const [state, setState] = useState({ offers: [], loading: true });
  const [revision, setRevision] = useState(0);
  const reload = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    if (!user?.user_id) { setState({ scope, offers: [], loading: false }); return () => controller.abort(); }
    setState((previous) => ({ scope, offers: previous.scope === scope ? previous.offers : [], recommendation: previous.scope === scope ? previous.recommendation : null, loading: true }));
    queueMicrotask(() => {
      if (controller.signal.aborted) return;
      axios.get(`${getApiUrl()}/module-offers`, { withCredentials: true, signal: controller.signal, timeout: 15000 })
        .then(({ data }) => { if (!controller.signal.aborted) setState({ scope, offers: data.offers, recommendation: data.recommendation, recommendationStatus: data.recommendation_status, loading: false }); })
        .catch(() => { if (!controller.signal.aborted) setState({ scope, offers: [], loading: false, error: 'Impossible de charger les modules.' }); });
    });
    return () => controller.abort();
  }, [scope, revision, user?.user_id]);
  useEffect(() => { window.addEventListener('module-offers:updated', reload); return () => window.removeEventListener('module-offers:updated', reload); }, [reload]);
  return { ...(state.scope === scope ? state : { offers: [], loading: true }), reload };
};